/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import moment from 'moment-timezone'
import Handlebars from 'handlebars';
import con from "@/firebase/firebaseInit.ts";
import firebase from 'firebase';
import ls from "@/common/localStorage"


//var cn = 'OA_UAT_C1591205467009E1591206650065';
var cn = ls.getSessionEventCollectionName();
var S3GETVideoUploadURL = con.S3GETVideoUploadURL;
var S3GETVideoDownloadURL = con.S3GETVideoDownloadURL;
var S3LSGETVideoUploadURL = con.S3LSGETVideoUploadURL;
var S3GETLiveSessionInfo = con.S3GETLiveSessionInfo;
var S3SETVideoScheduleTime = con.S3SETVideoScheduleTime;
var SessionAttendeeMappingAPI = con.SessionAttendeeMappingAPI;
var ZoomCreateWebinarAPI = con.ZoomCreateWebinarAPI;
var ZoomCreateMeetingAPI = con.ZoomCreateMeetingAPI
var ZoomWSHostId = con.ZoomWSHostId;
var ZoomWSPassword = con.ZoomWSPassword;
var ZoomCreateUserAPI = con.ZoomCreateUserAPI
var ZoomUserListAPI = con.ZoomUserListAPI
var ZoomMakeWebinarHost = con.ZoomMakeWebinarHost
var ZoomCreateUserHostAPI = con.ZoomCreateUserHostAPI
var ZoomWebinarEnableRecordingAPI = con.ZoomWebinarEnableRecordingAPI
var ZoomEnableRTMPmeeting = con.ZoomEnableRTMPmeeting
var ZoomEnableMeetingRecordingAPI = con.ZoomEnableMeetingRecordingAPI
var ZoomEnableBreakout = con.ZoomEnableBreakout
var ZoomCoHostAPI = con.ZoomCoHostAPI
var CreateRTMPSession = con.CreateRTMPSession
var sendpushApiKey = con.sendpushApiKey
var FirebaseAuthApi = con.FirebaseAuthApi;
var sessionRef = con.eventDB.collection(cn).doc("SessionList").collection("Sessions");
const qnaRef = con.eventDB.collection(cn).doc('UserVideoActivity').collection('Session')
var storageRef = con.storageRef;
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ")
var Session_UserId = ls.getSessionValueByKey('UserId');
var Sesion_StreamingClient = ls.getSessionValueByKey("Sesion_StreamingClient")
var Sesion_ApprovalType = ls.getSessionValueByKey("Sesion_ApprovalType")
var Session_ClientName = ls.getSessionValueByKey('ClientName');
var Session_Event_TZ = ls.getSessionValueByKey('Session_Event_TZ');
var Session_Event_FullName = ls.getSessionValueByKey('Session_Event_FullName');
var Session_CustomDomain = ls.getSessionValueByKey('CustomDomain');
var clientRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id);
var eventRef = con.eventDB.collection(cn).doc("EventInfo");
var ZoomMeetingAnalytics = con.ZoomMeetingAnalytics
var ZoomWebinarAnalytics = con.ZoomWebinarAnalytics
var GetPlanUssage = con.GetPlanUssage
var RecordedVideoUrlsAPI = con.RecordedVideoUrlsAPI
var DeleteAttendeeApiKey = con.DeleteAttendeeApiKey
var LivePanelToOnDemandVideoAPI = con.LivePanelToOnDemandVideoAPI
var AddSessionAPI = con.AddSessionAPI
var UploadFilesAPI = con.UploadFilesAPI
var SchedulingAPI = con.SchedulingAPI
var DeleteSchedulingAPI = con.DeleteSchedulingAPI
var StartNotificationSendAPI = con.StartNotificationSendAPI
var Environment = con.Environment
var GetSessionBatch = con.GetSessionBatch
var getAllSessions = con.getAllSessions
var rptsession = con.rptsession
var generateQR = con.generateQR

export default {
    cloneSession(context) {
        return new Promise((resolve, reject) => {
            let markers = []
            sessionRef.doc("99909071").get().then(doc => {
                debugger;
                if (doc.exists) {
                    var newSessionId = "99909072";
                    sessionRef.doc(newSessionId).get().then(doc1 => {
                        debugger;
                        if (!doc1.exists) {
                            var docObj = doc.data();
                            //context.dispatch('getAutoId').then(AutoID => {
                            //docObj.SessionId = AutoID;
                            docObj.SessionId = newSessionId;
                            docObj.IsPublished = false;
                            //docObj.SessionId = new Date().getTime().toString();

                            //alert("Success : " + docObj.SessionId)
                            // docObj.SessionId = getAutoId().then(function (){
                            //     alert("Success1111111111111")
                            // });
                            sessionRef.doc(docObj.SessionId).set(docObj).then(function () {
                                alert("Success")
                                resolve(markers)
                            }).catch(function (er) {
                                //console.log('Error getting session:', error)
                                reject(er)
                            })
                            //});
                            //commit('SET_SESSIONS', markers)
                        }
                    }).catch(function (error) {
                        //console.log('Error getting session:', error)
                        reject(error)
                    })
                }
            }).catch(function (error) {
                //console.log('Error getting session:', error)
                reject(error)
            })

        })
    },
    fetchSessionsBK({ commit }) {
        return new Promise((resolve, reject) => {
            let markers = []
            sessionRef.orderBy("StartDate", "asc").get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    var docObj = doc.data();
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    markers.push(docObj)
                })
                commit('SET_SESSIONS', markers)
                resolve(markers)
            }).catch(function (error) {
                //console.log('Error getting session:', error)
                reject(error)
            })

        })
    },
    fetchSessions(context) {
        return new Promise((resolve, reject) => {
            let markers = [];
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },
            };
            axios.post(getAllSessions, requestData, { headers: headers }).then(function (res) {
                if (res.data.status == 0) {
                    markers = res.data.sessions
                }

                context.commit('SET_SESSIONS', markers)
                resolve(markers)

            }).catch(function (error) {
                reject(error)
            })
        })
    },
    fetchSessionsMapping({ commit }) {
        return new Promise((resolve, reject) => {
            let markers = []
            let count = 0
            let totallength = 0;
            sessionRef.orderBy("CreatedDate", "desc").get().then(querySnapshot => {
                totallength = querySnapshot.docs.length
                querySnapshot.docs.forEach(doc => {
                    var docObj = doc.data();
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    //sessionRef.doc(`${doc.id}`).collection('MappedAttendees').get().then(function(attendees) {
                    //docObj.NumberofAttendees = attendees.docs.length
                    //sessionRef.doc(`${doc.id}`).collection('MappedGroups').get().then(function(groups) {
                    //docObj.NumberofGroups = groups.docs.length
                    markers.push(docObj)
                    /*count++;
                    if (count == totallength) {
                        commit('SET_SESSIONSMAPPING', markers)
                        resolve(markers)
                    }*/
                    //})
                    //})
                })
                commit('SET_SESSIONSMAPPING', markers)
                resolve(markers)
            })

        })
    },
    fetchSession(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        Description: '',
                        DescriptionShort: '',
                        EndDate: null,
                        Resources: [],
                        Location: { LocationID: 0, LocationName: '' },
                        MappedSpeakers: [],
                        MappedHosts: [],
                        MappedCoHost: null,
                        Name: '',
                        StreamingClient: 'Zoom',
                        approval_type: 0,
                        IsZoomRTMP: true,
                        IsRTMP: false,
                        WebinarCapacity: null,
                        SpeakersJoinZoomWebSDK: false,
                        SessionSettings: { PostRollImageURL: '', PreRollImageURL: '' },
                        StartDate: null,
                        Track: {
                            TrackID: '',
                            TrackName: '',
                            ColorCode: ''
                        },
                        PlayerControl: true,
                        EnableGroupChat: true,
                        ShowAttendeeList: true,
                        EnableBottomBar: false,
                        PhotoWallAlbum: null,
                        EmbedCode: null,
                        Active: 'PhotoWallAlbum',
                        ODVideoURL: null,
                        ODVideoLengthMinutes: null,
                        LSDateTime: null,
                        LSVideoURL: null,
                        IsManualUrl: false,
                        RTMPURL: null,
                        StreamKey: null,
                        LSVideoURLType: 'LSVideoURL',
                        LSVideoLengthMinutes: null,
                        SessionTypeDetails: { TypeID: 3, TypeName: "Live Panel" },
                        LivePanel: true,
                        TypeID: 3,
                        QnAModeration: false,
                        AllowPostingQuestionsAnonymously: false,
                        ConvertToOnDemandVideoOnSessionEnd: true,
                        QnAAutoPublish: false,
                        EnableHelpORSettings: false,
                        EnableLiveQnA: false,
                        EnableRaiseHand: false,
                        EnableInviteSessionAttendee: false,
                        EnableSpotlight: false,
                        ShowAgenda: false,
                        ShowSpeakerList: true,
                        AudiencePoll: false,
                        RoundTables: null,
                        MapExistingRoundTableGroup: true,
                        RTStreamingClient: 'Web',
                        Spectate: false,
                        TableType: 'Open',
                        RTHost: null,
                        NumberOfSeatsPerTable: 8,
                        NumberOfTables: 1,
                        Imperson: false,
                        InPersonIcon: null,
                        InPersonLabel: null,
                        //InPersonURL: null,
                        AttendeeURL: null,
                        SpeakerURL: null,
                        HostURL: null,
                        IsPublished: true,
                        SessionVisibleFor: { label: 'Everyone', value: 1 },
                        ShowSessionStartNotificationMessage: false,
                        DisplayBeforeSessionStartMin: 5,
                        DisplayBeforeSessionStartMin_Secondary: 120,
                        DisplayBeforeSessionStart_Hour: 12,
                        StartNotificationSendTo: 'Email',
                        StartNotificationSendToThird: 'EmailOnly',
                        StartNotificationMessage: con.Environment == 'EDU' ? "Dear {{FirstName}} You have an upcoming class for {{EventName}} {{SessionName}} Date: {{StartDate}} - {{EndTime}}. Please login {{CountDownTime}} before your session." : "Dear {{FirstName}} this is a gentle reminder that {{SessionName}} of {{EventName}} will begin in {{CountDownTime}}. Date: {{StartDate}} to {{EndDate}}.",
                        DisplayBeforeSessionEndSecs: 60,
                        ShowSessionEndNotificationMessage: true,
                        NotificationMessage: "This session is about to end in {{countdown}}",
                        approval_type: Sesion_ApprovalType != undefined ? Number(Sesion_ApprovalType) : 0,
                        HideTime: false,
                        HideJoinButton: false,
                        HideTrack: false,
                        HideTitle: false,
                        HideShortDescription: false,
                        HideSpeakers: false,
                        ShowInSeparateRow: false,
                        ShowBeforeConcurrentSessions: true,
                        ShowFeatureImage: false,
                        FeatureImage: null
                    }
                })
            } else {
                let docObj = new Object
                sessionRef.doc(`${id}`).get().then(function (doc) {
                    docObj = doc.data();
                    docObj.StreamingClient = doc.data().StreamingClient ? doc.data().StreamingClient : 'Web';
                    docObj.approval_type = doc.data().approval_type != undefined ? doc.data().approval_type : 0;
                    docObj.MappedHosts = doc.data().StreamingClient == 'Zoom' ? [doc.data().MappedHosts[0]] : doc.data().MappedHosts;
                    docObj.MappedCoHost = doc.data().MappedCoHost ? doc.data().MappedCoHost : null;
                    docObj.IsZoomRTMP = doc.data().IsZoomRTMP ? doc.data().IsZoomRTMP : false;
                    docObj.IsRTMP = doc.data().IsRTMP ? doc.data().IsRTMP : false;
                    docObj.WebinarCapacity = doc.data().WebinarCapacity ? doc.data().WebinarCapacity : null;
                    docObj.SpeakersJoinZoomWebSDK = doc.data().SpeakersJoinZoomWebSDK ? doc.data().SpeakersJoinZoomWebSDK : false;
                    docObj.EndDate = doc.data().EndDate ? new Date(doc.data().EndDate.seconds * 1000).toUTCString() : null;
                    docObj.StartDate = doc.data().StartDate ? new Date(doc.data().StartDate.seconds * 1000).toUTCString() : null;
                    let SessionTypeDetails = doc.data().SessionTypeDetails;
                    docObj.TypeID = (SessionTypeDetails.TypeID ? SessionTypeDetails.TypeID : 3)
                    docObj.IsManualUrl = false
                    docObj.ShowSpeakerList = (SessionTypeDetails.ShowSpeakerList != undefined ? SessionTypeDetails.ShowSpeakerList : true)
                    docObj.AudiencePoll = (SessionTypeDetails.AudiencePoll != undefined ? SessionTypeDetails.AudiencePoll : false)
                    docObj.ShowAgenda = (SessionTypeDetails.ShowAgenda != undefined ? SessionTypeDetails.ShowAgenda : false)
                    docObj.EnableRaiseHand = (SessionTypeDetails.EnableRaiseHand != undefined ? SessionTypeDetails.EnableRaiseHand : false)
                    docObj.EnableInviteSessionAttendee = (SessionTypeDetails.EnableInviteSessionAttendee != undefined ? SessionTypeDetails.EnableInviteSessionAttendee : false)
                    docObj.EnableSpotlight = (SessionTypeDetails.EnableSpotlight != undefined ? SessionTypeDetails.EnableSpotlight : false)
                    docObj.EnableLiveQnA = (SessionTypeDetails.EnableLiveQnA != undefined ? SessionTypeDetails.EnableLiveQnA : false)
                    docObj.EnableHelpORSettings = (SessionTypeDetails.EnableHelpORSettings != undefined ? SessionTypeDetails.EnableHelpORSettings : false)
                    docObj.PlayerControl = (SessionTypeDetails.PlayerControl != undefined ? SessionTypeDetails.PlayerControl : true)
                    docObj.EnableGroupChat = (SessionTypeDetails.EnableGroupChat != undefined ? SessionTypeDetails.EnableGroupChat : true)
                    docObj.ShowAttendeeList = (SessionTypeDetails.ShowAttendeeList != undefined ? SessionTypeDetails.ShowAttendeeList : true)
                    docObj.EnableBottomBar = (SessionTypeDetails.EnableBottomBar != undefined ? SessionTypeDetails.EnableBottomBar : false)
                    docObj.PhotoWallAlbum = (SessionTypeDetails.PhotoWallAlbum != undefined ? SessionTypeDetails.PhotoWallAlbum : null)
                    docObj.EmbedCode = (SessionTypeDetails.EmbedCode ? SessionTypeDetails.EmbedCode : null)
                    docObj.Active = (SessionTypeDetails.Active ? SessionTypeDetails.Active : 'PhotoWallAlbum')
                    docObj.ODVideoURL = (SessionTypeDetails.TypeID == 1 ? SessionTypeDetails.VideoURL : null)
                    docObj.ODVideoLengthMinutes = (SessionTypeDetails.TypeID == 1 ? SessionTypeDetails.VideoLengthMinutes : null)
                    docObj.LSDateTime = (SessionTypeDetails.TypeID == 2 && SessionTypeDetails.StartDateTime ? new Date(SessionTypeDetails.StartDateTime.seconds * 1000).toUTCString() : null)
                    docObj.LSVideoURL = (SessionTypeDetails.TypeID == 2 ? SessionTypeDetails.LiveStreamURL : null)
                    docObj.RTMPURL = (SessionTypeDetails.TypeID == 2 ? SessionTypeDetails.RTMPURL : null)
                    docObj.StreamKey = (SessionTypeDetails.TypeID == 2 ? SessionTypeDetails.StreamKey : null)
                    docObj.LSVideoURLType = (SessionTypeDetails.TypeID == 2 && SessionTypeDetails.RTMPURL ? 'RTMPURL' : 'LSVideoURL')
                    docObj.LSVideoLengthMinutes = (SessionTypeDetails.TypeID == 2 ? SessionTypeDetails.StreamLengthMinutes : null)
                    docObj.LivePanel = (SessionTypeDetails.TypeID == 3 ? true : false)
                    docObj.QnAModeration = (SessionTypeDetails.QnAModeration != undefined ? SessionTypeDetails.QnAModeration : false)
                    docObj.AllowPostingQuestionsAnonymously = (SessionTypeDetails.AllowPostingQuestionsAnonymously != undefined ? SessionTypeDetails.AllowPostingQuestionsAnonymously : false)
                    docObj.ConvertToOnDemandVideoOnSessionEnd = (SessionTypeDetails.ConvertToOnDemandVideoOnSessionEnd != undefined ? SessionTypeDetails.ConvertToOnDemandVideoOnSessionEnd : true)
                    docObj.QnAAutoPublish = (SessionTypeDetails.QnAAutoPublish != undefined ? SessionTypeDetails.QnAAutoPublish : false)
                    /************ ROUND TABLE *******/
                    if (SessionTypeDetails.TypeID == 4 && SessionTypeDetails.RoundTableTopic) {
                        docObj.RoundTables = {
                            TopicId: SessionTypeDetails.RoundTableTopic.TopicId,
                            TopicName: SessionTypeDetails.RoundTableTopic.TopicName,
                            TopicDisplayName: SessionTypeDetails.RoundTableTopic.TopicDisplayName,
                            TopicTableCapacity: SessionTypeDetails.RoundTableTopic.TopicTableCapacity
                        }
                    }
                    else
                        docObj.RoundTables = []
                    docObj.MapExistingRoundTableGroup = (SessionTypeDetails.TypeID == 4 && SessionTypeDetails.MapExistingRoundTableGroup != undefined ? SessionTypeDetails.MapExistingRoundTableGroup : true)
                    docObj.RTStreamingClient = (SessionTypeDetails.TypeID == 4 && SessionTypeDetails.RTStreamingClient ? SessionTypeDetails.RTStreamingClient : 'Web')
                    //docObj.Spectate = (SessionTypeDetails.TypeID == 4 && SessionTypeDetails.SpectatorEnabled ? SessionTypeDetails.SpectatorEnabled != undefined : true)
                    docObj.Spectate = false
                    docObj.TableType = (SessionTypeDetails.TypeID == 4 && SessionTypeDetails.TableType ? SessionTypeDetails.TableType : 'Open')
                    docObj.RTHost = (SessionTypeDetails.TypeID == 4 && SessionTypeDetails.RTHost ? SessionTypeDetails.RTHost : null)
                    docObj.NumberOfSeatsPerTable = (SessionTypeDetails.TypeID == 4 && SessionTypeDetails.NumberOfSeatsPerTable ? SessionTypeDetails.NumberOfSeatsPerTable : 8)
                    docObj.NumberOfTables = (SessionTypeDetails.TypeID == 4 && SessionTypeDetails.NumberOfTables ? SessionTypeDetails.NumberOfTables : 1)
                    /************ ROUND TABLE *******/
                    docObj.Imperson = (SessionTypeDetails.TypeID == 5 ? true : false)
                    docObj.InPersonIcon = ([5, 6].includes(SessionTypeDetails.TypeID) && SessionTypeDetails.InPersonIcon ? SessionTypeDetails.InPersonIcon : null)
                    docObj.InPersonLabel = ([5, 6].includes(SessionTypeDetails.TypeID) && SessionTypeDetails.InPersonLabel ? SessionTypeDetails.InPersonLabel : null)
                    //docObj.InPersonURL = (SessionTypeDetails.TypeID == 5 && SessionTypeDetails.InPersonURL ? SessionTypeDetails.InPersonURL : null)
                    docObj.AttendeeURL = (SessionTypeDetails.TypeID == 5 && SessionTypeDetails.AttendeeURL ? SessionTypeDetails.AttendeeURL : null)
                    docObj.SpeakerURL = (SessionTypeDetails.TypeID == 5 && SessionTypeDetails.SpeakerURL ? SessionTypeDetails.SpeakerURL : null)
                    docObj.HostURL = (SessionTypeDetails.TypeID == 5 && SessionTypeDetails.HostURL ? SessionTypeDetails.HostURL : null)
                    docObj.SessionVisibleFor = docObj.SessionVisibleFor ? docObj.SessionVisibleFor : { label: 'Everyone', value: 1 }

                    docObj.Resources = (doc.data().Resources ? doc.data().Resources : [])
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    docObj.DisplayBeforeSessionEndSecs = docObj.DisplayBeforeSessionEndSecs ? docObj.DisplayBeforeSessionEndSecs : 60;
                    docObj.ShowSessionEndNotificationMessage = docObj.ShowSessionEndNotificationMessage != undefined ? docObj.ShowSessionEndNotificationMessage : true;
                    docObj.NotificationMessage = docObj.NotificationMessage ? docObj.NotificationMessage : "This session is about to end in {{countdown}}";
                    docObj.DisplayBeforeSessionStartMin = docObj.DisplayBeforeSessionStartMin != undefined ? docObj.DisplayBeforeSessionStartMin : 5;
                    docObj.DisplayBeforeSessionStartMin_Secondary = docObj.DisplayBeforeSessionStartMin_Secondary != undefined ? docObj.DisplayBeforeSessionStartMin_Secondary : 120;
                    docObj.DisplayBeforeSessionStart_Hour = docObj.DisplayBeforeSessionStart_Hour != undefined ? docObj.DisplayBeforeSessionStart_Hour : 12;
                    docObj.ShowSessionStartNotificationMessage = docObj.ShowSessionStartNotificationMessage != undefined ? docObj.ShowSessionStartNotificationMessage : false;
                    docObj.StartNotificationSendTo = docObj.StartNotificationSendTo != undefined ? docObj.StartNotificationSendTo : 'Email';
                    docObj.StartNotificationSendToThird = docObj.StartNotificationSendToThird != undefined ? docObj.StartNotificationSendToThird : 'EmailOnly';
                    docObj.StartNotificationMessage = docObj.StartNotificationMessage ? docObj.StartNotificationMessage : null;
                    if (SessionTypeDetails.TypeID == 5) {
                        docObj.HideTime = SessionTypeDetails.HideTime != undefined ? SessionTypeDetails.HideTime : false;
                        docObj.HideJoinButton = SessionTypeDetails.HideJoinButton != undefined ? SessionTypeDetails.HideJoinButton : false;
                        docObj.HideTrack = SessionTypeDetails.HideTrack != undefined ? SessionTypeDetails.HideTrack : false;
                        docObj.HideTitle = SessionTypeDetails.HideTitle != undefined ? SessionTypeDetails.HideTitle : false;
                        docObj.HideShortDescription = SessionTypeDetails.HideShortDescription != undefined ? SessionTypeDetails.HideShortDescription : false;
                        docObj.HideSpeakers = SessionTypeDetails.HideSpeakers != undefined ? SessionTypeDetails.HideSpeakers : false;
                        docObj.ShowInSeparateRow = SessionTypeDetails.ShowInSeparateRow != undefined ? SessionTypeDetails.ShowInSeparateRow : false;
                        docObj.ShowBeforeConcurrentSessions = SessionTypeDetails.ShowBeforeConcurrentSessions != undefined ? SessionTypeDetails.ShowBeforeConcurrentSessions : true;
                        docObj.ShowFeatureImage = SessionTypeDetails.ShowFeatureImage != undefined ? SessionTypeDetails.ShowFeatureImage : false;
                        docObj.FeatureImage = SessionTypeDetails.FeatureImage != undefined ? SessionTypeDetails.FeatureImage : null;
                    }
                    //console.log(SessionTypeDetails)                
                    resolve({ status: 200, data: docObj })
                }).catch(function (error) {
                    //console.log('Error getting mapped session:', error)
                    reject(error)
                })
            }

        })
    },
    getFirebaseAccessToken(context) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken")
            resolve(accessToken);
        })
    },
    mapSessionAttendeeStatusChange(context, field) {
        return new Promise((resolve, reject) => {
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                //console.log(accessToken)
                //let token = JSON.stringify(JSON.parse(accessToken))
                let headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "content-type": 'application/json'
                }


                let requestData = {
                    "source": "web",
                    //"token": `${accessToken}`,
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": {
                        "sessions": field.sessions,
                        "value": {
                            "IsPublished": field.IsPublished
                        }
                    }
                }
                //console.log(requestData)
                axios.put(SessionAttendeeMappingAPI, requestData, { headers: headers }).then((response) => {
                    //console.log(response)
                    resolve({ status: 200, message: "Status Changed" })
                }).catch((error) => {
                    //console.log(error) 
                    resolve({ status: 500, message: "Status Not Changed" })
                })

            })
        })
    },
    uploadFiles(context, field) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },
                files: field
            };
            axios.post(UploadFilesAPI, requestData, { headers: headers }).then(function (res) {
                if (res.data.status == 0)
                    resolve({ status: 200, data: res.data.data })
                else
                    resolve({ status: 500, data: [] })
            }).catch(err => { reject(err) })
        })
    },
    updateStatus(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                SessionId: `${field.id}`,
                IsPublished: field.IsPublished
            }
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },
                "data": docObj
            };
            axios.put(AddSessionAPI, requestData, { headers: headers }).then(function (res) {
                context.dispatch('mapSessionAttendeeStatusChange', { sessions: [field.Session], IsPublished: field.IsPublished }).then(res => {
                    resolve({ status: 200, message: 'Data Updated.' });
                })
            }).catch(function (error) {
                reject(error)
            })
        })
    },
    updateSession(context, field) {
        //console.log(atob(field.id));
        //console.log(field);
        let track = {
            TrackID: '',
            TrackName: '',
            ColorCode: ''
        }
        if (field.data.Track) {
            track = field.data.Track;
        }
        return new Promise(async (resolve, reject) => {
            let docObj = {
                SessionId: field.id,
                Description: field.data.Description,
                DescriptionShort: field.data.DescriptionShort,
                //StartDate: new Date(field.data.StartDate),
                //EndDate: new Date(field.data.EndDate),
                StartDate: (field.data.StartDate ? field.data.StartDate : null),
                EndDate: (field.data.EndDate ? field.data.EndDate : null),
                Timezone: Session_Event_TZ,
                DisplayBeforeSessionEndSecs: (field.data.DisplayBeforeSessionEndSecs ? field.data.DisplayBeforeSessionEndSecs : 60),
                ShowSessionEndNotificationMessage: (field.data.ShowSessionEndNotificationMessage != undefined ? field.data.ShowSessionEndNotificationMessage : true),
                NotificationMessage: (field.data.NotificationMessage ? field.data.NotificationMessage : null),

                DisplayBeforeSessionStartMin: field.data.DisplayBeforeSessionStartMin != undefined ? field.data.DisplayBeforeSessionStartMin : 5,
                DisplayBeforeSessionStartMin_Secondary: field.data.DisplayBeforeSessionStartMin_Secondary != undefined ? field.data.DisplayBeforeSessionStartMin_Secondary : 120,
                DisplayBeforeSessionStart_Hour: field.data.DisplayBeforeSessionStart_Hour != undefined ? field.data.DisplayBeforeSessionStart_Hour : 12,
                ShowSessionStartNotificationMessage: field.data.ShowSessionStartNotificationMessage != undefined ? field.data.ShowSessionStartNotificationMessage : false,
                StartNotificationSendTo: field.data.StartNotificationSendTo != undefined ? field.data.StartNotificationSendTo : 'Email',
                StartNotificationSendToThird: field.data.StartNotificationSendToThird != undefined ? field.data.StartNotificationSendToThird : 'EmailOnly',
                StartNotificationMessage: field.data.StartNotificationMessage ? field.data.StartNotificationMessage : null,

                Location: field.data.Location,
                MappedSpeakers: field.data.MappedSpeakers,
                Name: field.data.Name.trim(),
                IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,
                SessionSettings: field.data.SessionSettings,
                //Resources: [],    
                SessionVisibleFor: field.data.SessionVisibleFor,
                Track: track,
                Batch: ['EDU', 'UAT'].includes(con.Environment) ? field.Batch : null,
                //LastModifiedDate: new Date(),
                //approval_type: field.data.approval_type ? field.data.approval_type : 2,
                SessionLogo: field.data.SessionLogo != undefined ? field.data.SessionLogo : ""
            }

            let notificationScheduleErrorObj = null;
            if (field.data.StreamingClient == 'Web' || field.data.IsZoomRTMP) {
                if (field.data.StreamingClient == 'Web') {
                    docObj.MappedHosts = field.data.MappedHosts
                    docObj.MappedCoHost = field.data.MappedCoHost
                }

                // Notification Schedule API call
                if (![5, 6].includes(field.data.TypeID) && field.data.ShowSessionStartNotificationMessage) {
                    if (docObj.StartDate > new Date()) {
                        let NotificationHtml = field.NotificationHtml
                        let NotificationSubject = field.NotificationSubject
                        context.dispatch('deleteNotificationSchedule', docObj);
                        let scheduledTaskId = await context.dispatch('setNotificationSchedule', { ...docObj, NotificationHtml, NotificationSubject }).then(sobj => {
                            docObj.StartNotificationScheduledTaskId = sobj.scheduledTaskId
                            docObj.StartNotificationScheduledTaskId_Secondary = sobj.scheduledTaskId2
                            docObj.StartNotificationScheduledTaskId_Third = sobj.scheduledTaskId3
                            if (sobj.error) {
                                notificationScheduleErrorObj = {
                                    errorMessage: sobj.error,
                                    errorField: sobj.errorField
                                }
                            }
                        })
                    }
                }
                else if (![5, 6].includes(field.data.TypeID) && field.data.ShowSessionStartNotificationMessage == false) {

                    await context.dispatch('deleteNotificationSchedule', docObj)
                    docObj.StartNotificationScheduledTaskId = null
                    docObj.StartNotificationScheduledTaskId_Secondary = null
                    docObj.StartNotificationScheduledTaskId_Third = null
                }

            }

            if (field.data.TypeID == 1) {
                docObj.SessionTypeDetails = {
                    TypeID: 1,
                    TypeName: "On Demand",
                    PlayerControl: field.data.PlayerControl,
                    EnableGroupChat: field.data.EnableGroupChat,
                    ShowAttendeeList: field.data.ShowAttendeeList,
                    EnableBottomBar: field.data.EnableBottomBar,
                    PhotoWallAlbum: field.data.PhotoWallAlbum,
                    EmbedCode: field.data.EmbedCode,
                    Active: field.data.Active,
                    VideoURL: field.data.IsManualUrl ? field.data.ODVideoURL : null,
                    VideoLengthMinutes: field.data.ODVideoLengthMinutes
                }

            } else if (field.data.TypeID == 2) {
                docObj.SessionTypeDetails = {
                    TypeID: 2,
                    TypeName: "Live Stream",
                    LiveStreamURL: field.data.IsManualUrl ? field.data.LSVideoURL : null,
                    RTMPURL: field.data.RTMPURL,
                    PlayerControl: field.data.PlayerControl,
                    EnableGroupChat: field.data.EnableGroupChat,
                    ShowAttendeeList: field.data.ShowAttendeeList,
                    EnableBottomBar: field.data.EnableBottomBar,
                    PhotoWallAlbum: field.data.PhotoWallAlbum,
                    EmbedCode: field.data.EmbedCode,
                    Active: field.data.Active,
                    StartDateTime: (field.data.LSDateTime ? field.data.LSDateTime : null),
                    StreamLengthMinutes: field.data.LSVideoLengthMinutes,
                    StreamKey: field.data.StreamKey
                }
            } else if (field.data.TypeID == 3) {
                docObj.SessionTypeDetails = {
                    TypeID: 3,
                    TypeName: "Live Panel",
                    QnAModeration: field.data.QnAModeration,
                    AllowPostingQuestionsAnonymously: field.data.AllowPostingQuestionsAnonymously,
                    ConvertToOnDemandVideoOnSessionEnd: field.data.ConvertToOnDemandVideoOnSessionEnd,
                    QnAAutoPublish: field.data.QnAAutoPublish,
                    EnableHelpORSettings: field.data.EnableHelpORSettings,
                    EnableLiveQnA: field.data.EnableLiveQnA,
                    EnableRaiseHand: field.data.EnableRaiseHand,
                    EnableInviteSessionAttendee: field.data.EnableInviteSessionAttendee,
                    EnableSpotlight: field.data.EnableSpotlight,
                    ShowAgenda: field.data.ShowAgenda,
                    ShowAttendeeList: field.data.ShowAttendeeList,
                    ShowSpeakerList: field.data.ShowSpeakerList,
                    AudiencePoll: field.data.AudiencePoll,
                    EnableGroupChat: field.data.EnableGroupChat
                }
                /*if(field.data.QnAModeration)
                {
                    context.dispatch('qnaPublishAll', {SessionId:field.id})
                }*/
            } else if (field.data.TypeID == 5) {
                docObj.SessionTypeDetails = {
                    TypeID: 5,
                    TypeName: "In-person / Custom",
                    InPersonIcon: field.data.InPersonIcon,
                    InPersonLabel: field.data.InPersonLabel,
                    //InPersonURL: field.data.InPersonURL,
                    AttendeeURL: field.data.AttendeeURL,
                    SpeakerURL: field.data.SpeakerURL,
                    HostURL: field.data.HostURL,
                    HideTime: field.data.HideTime,
                    HideJoinButton: field.data.HideJoinButton,
                    HideTrack: field.data.HideTrack,
                    HideTitle: field.data.HideTitle,
                    HideShortDescription: field.data.HideShortDescription,
                    HideSpeakers: field.data.HideSpeakers,
                    ShowInSeparateRow: field.data.ShowInSeparateRow,
                    ShowBeforeConcurrentSessions: field.data.ShowBeforeConcurrentSessions,
                    ShowFeatureImage: field.data.ShowFeatureImage,
                    FeatureImage: field.data.FeatureImage,
                    QnAModeration: field.data.QnAModeration,
                    AllowPostingQuestionsAnonymously: field.data.AllowPostingQuestionsAnonymously,
                    QnAAutoPublish: field.data.QnAAutoPublish,
                    EnableLiveQnA: field.data.EnableLiveQnA,
                    AudiencePoll: field.data.AudiencePoll,
                    EnableGroupChat: field.data.EnableGroupChat
                }
            } else if (field.data.TypeID == 6) {
                docObj.SessionTypeDetails = {
                    TypeID: 6,
                    TypeName: "In-person",
                    InPersonIcon: field.data.InPersonIcon,
                    InPersonLabel: field.data.InPersonLabel,
                    QnAAutoPublish: field.data.QnAAutoPublish,
                    EnableLiveQnA: field.data.EnableLiveQnA,
                    AudiencePoll: field.data.AudiencePoll,
                    EnableGroupChat: field.data.EnableGroupChat,
                    QnAModeration: field.data.QnAModeration,
                    AllowPostingQuestionsAnonymously: field.data.AllowPostingQuestionsAnonymously
                }
            } else if (field.data.TypeID == 4) {
                docObj.SessionTypeDetails = {
                    TypeID: 4,
                    TypeName: "Round Table",
                    RoundTableTopic: field.data.RoundTables,
                    //MapExistingRoundTableGroup: field.data.MapExistingRoundTableGroup != undefined ? field.data.MapExistingRoundTableGroup :true,
                    //RTStreamingClient: field.data.RTStreamingClient ? field.data.RTStreamingClient : 'Web',
                    //Spectate: field.data.Spectate != undefined ? field.data.Spectate : true,
                    //PreAssigned: (field.data.TableType == 'Pre_assigned' ? true : false),
                    //RTHost: field.data.RTHost ? field.data.RTHost : null,
                    //NumberOfSeatsPerTable: field.data.NumberOfSeatsPerTable ? field.data.NumberOfSeatsPerTable : 0,
                    //NumberOfTables: field.data.NumberOfTables ? field.data.NumberOfTables : 0
                }
            }
            if (field.data.Resources) {
                docObj.Resources = field.data.Resources.filter(function (element) {
                    return typeof element == 'string';
                });
            }

            let agendaAttendees = field.SelectedAttendees;
            /*field.data.MappedSpeakers.filter(item=>{
                let found = field.SelectedAttendees.some(u=> item.AttendeeId == u.AttendeeId)
                if(!found)
                    agendaAttendees.push(item)
            })*/
            let agendaMapObj = {
                sessions: [{
                    SessionId: field.id,
                    StartDate: docObj.StartDate,
                    EndDate: docObj.EndDate,
                    Track: docObj.Track,
                    Name: docObj.Name
                }],
                attendees: docObj.SessionVisibleFor.value == 3 ? agendaAttendees : [],
                unmap_attendees: docObj.SessionVisibleFor.value == 3 ? [] : agendaAttendees,
                mapgroups: docObj.SessionVisibleFor.value == 2 ? field.SelectedGroups : [],
                unmapgroups: docObj.SessionVisibleFor.value == 2 ? [] : field.SelectedGroups
            }
            if ([2, 3].includes(docObj.SessionVisibleFor.value)) {
                context.dispatch('agendaManagement/mapSessionAttendee', agendaMapObj, { root: true });
            }

            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },
                "data": docObj
            };


            sessionRef.doc(`${field.id}`).get().then(function (doc) {
                if (docObj.SessionTypeDetails.TypeID == 1) {
                    if (docObj.SessionTypeDetails.VideoURL == null || docObj.SessionTypeDetails.VideoURL == undefined) {
                        if (doc.data().SessionTypeDetails.VideoURL)
                            docObj.SessionTypeDetails.VideoURL = doc.data().SessionTypeDetails.VideoURL
                        else
                            docObj.SessionTypeDetails.VideoURL = null
                    }
                }
                if (docObj.SessionTypeDetails.TypeID == 2) {
                    if (docObj.SessionTypeDetails.LiveStreamURL == null || docObj.SessionTypeDetails.LiveStreamURL == undefined) {
                        if (doc.data().SessionTypeDetails.LiveStreamURL)
                            docObj.SessionTypeDetails.LiveStreamURL = doc.data().SessionTypeDetails.LiveStreamURL
                        else
                            docObj.SessionTypeDetails.LiveStreamURL = null
                    }
                }
                requestData.data = docObj;
                if (docObj.SessionTypeDetails.TypeID == 2) {
                    let Session_StartDate_UTC = moment(field.data.StartDate, 'MM/DD/YYYY HH:mm').tz(Session_Event_TZ).utc();
                    context.dispatch('setVideoScheduleTime', { sessionId: field.id, scheduleInUTC: field.scheduleInUTC, Session_StartDate_UTC: Session_StartDate_UTC }).then(res => {
                        if (res.status == 200) {
                            axios.put(AddSessionAPI, requestData, { headers: headers }).then(function (res) {
                                if (res.data.status == 0)
                                    resolve({ status: 200, message: 'Data Updated.', ScheduleTimeresponse: res, notificationScheduleError: notificationScheduleErrorObj })
                                else
                                    resolve({ status: 500, message: 'Data not Updated.', ScheduleTimeresponse: res })
                            })
                        } else {
                            resolve({ status: 500, message: 'Data not Updated.', ScheduleTimeresponse: res })
                        }
                    })
                } else {
                    axios.put(AddSessionAPI, requestData, { headers: headers }).then(function (res) {
                        if (res.data.status == 0)
                            resolve({ status: 200, message: 'Data Updated.', ScheduleTimeresponse: "", notificationScheduleError: notificationScheduleErrorObj })
                        else
                            resolve({ status: 500, message: 'Data not Updated.', ScheduleTimeresponse: "" })
                    })
                }
            })

        })
    },
    uploadRandomImage(context, file) {
        return new Promise((resolve, reject) => {
            if (file) {
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(cn + '/Session/LogoImage/' + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        resolve({ status: 200, message: 'Image Uploaded.', ImageSrc: url })
                    })
                }).catch(err => {
                    resolve({ status: 500, message: 'Image not Uploaded.', ImageSrc: null })
                })
            } else {
                resolve({ status: 500, message: 'Image not Uploaded.', ImageSrc: null })
            }
        })
    },
    uploadLogo(context, field) {
        return new Promise((resolve, reject) => {
            //------------------------ Update LOGO ----------------------------------------------

            if (field.data.file) {
                let file = field.data.file
                let metadata = {
                    'contentType': file.type
                }
                debugger;
                storageRef.child(cn + '/Session/LogoImage/' + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        sessionRef.doc(`${field.id}`).update({ SessionLogo: url.toString() }).then(function (doc) {
                            field.data.SessionLogo = url.toString()
                            //context.dispatch('updateRoundtable', field);
                            resolve({ status: 200, message: 'Data & File Updated.' })
                        })
                    })
                })
            } else {
                field.data.SessionLogo = null
                resolve({ status: 200, message: 'Data Updated.' })
            }
            //------------------------------------------------------------------------------------
        })
    },
    updateOtherSettings(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                SessionId: `${field.id}`
                //LastModifiedDate: new Date()
            }

            sessionRef.doc(`${field.id}`).get().then(function (doc) {
                docObj.SessionTypeDetails = doc.data().SessionTypeDetails
                if (field.data.TypeID == 1) {
                    docObj.SessionTypeDetails.PlayerControl = field.data.PlayerControl
                    docObj.SessionTypeDetails.EnableGroupChat = field.data.EnableGroupChat
                    docObj.SessionTypeDetails.ShowAttendeeList = field.data.ShowAttendeeList
                    docObj.SessionTypeDetails.ShowSpeakerList = field.data.ShowSpeakerList
                    docObj.SessionTypeDetails.EnableLiveQnA = field.data.EnableLiveQnA
                    docObj.SessionTypeDetails.QnAModeration = field.data.QnAModeration
                    docObj.SessionTypeDetails.AllowPostingQuestionsAnonymously = field.data.AllowPostingQuestionsAnonymously
                    docObj.SessionTypeDetails.QnAAutoPublish = field.data.QnAAutoPublish
                    docObj.SessionTypeDetails.EnableBottomBar = field.data.EnableBottomBar
                    docObj.SessionTypeDetails.PhotoWallAlbum = field.data.PhotoWallAlbum
                    docObj.SessionTypeDetails.EmbedCode = field.data.EmbedCode
                    docObj.SessionTypeDetails.Active = field.data.Active
                } else if (field.data.TypeID == 2) {
                    docObj.SessionTypeDetails.PlayerControl = field.data.PlayerControl
                    docObj.SessionTypeDetails.EnableGroupChat = field.data.EnableGroupChat
                    docObj.SessionTypeDetails.ShowAttendeeList = field.data.ShowAttendeeList
                    docObj.SessionTypeDetails.ShowSpeakerList = field.data.ShowSpeakerList
                    docObj.SessionTypeDetails.EnableLiveQnA = field.data.EnableLiveQnA
                    docObj.SessionTypeDetails.QnAModeration = field.data.QnAModeration
                    docObj.SessionTypeDetails.AllowPostingQuestionsAnonymously = field.data.AllowPostingQuestionsAnonymously
                    docObj.SessionTypeDetails.QnAAutoPublish = field.data.QnAAutoPublish
                    docObj.SessionTypeDetails.EnableBottomBar = field.data.EnableBottomBar
                    docObj.SessionTypeDetails.PhotoWallAlbum = field.data.PhotoWallAlbum
                    docObj.SessionTypeDetails.EmbedCode = field.data.EmbedCode
                    docObj.SessionTypeDetails.Active = field.data.Active
                } else if (field.data.TypeID == 3) {
                    docObj.SessionTypeDetails.QnAModeration = field.data.QnAModeration
                    docObj.SessionTypeDetails.AllowPostingQuestionsAnonymously = field.data.AllowPostingQuestionsAnonymously
                    docObj.SessionTypeDetails.ConvertToOnDemandVideoOnSessionEnd = field.data.ConvertToOnDemandVideoOnSessionEnd
                    docObj.SessionTypeDetails.QnAAutoPublish = field.data.QnAAutoPublish
                    docObj.SessionTypeDetails.EnableHelpORSettings = field.data.EnableHelpORSettings
                    docObj.SessionTypeDetails.EnableLiveQnA = field.data.EnableLiveQnA
                    docObj.SessionTypeDetails.EnableRaiseHand = field.data.EnableRaiseHand
                    docObj.SessionTypeDetails.EnableInviteSessionAttendee = field.data.EnableInviteSessionAttendee
                    docObj.SessionTypeDetails.EnableSpotlight = field.data.EnableSpotlight
                    docObj.SessionTypeDetails.ShowAgenda = field.data.ShowAgenda
                    docObj.SessionTypeDetails.ShowAttendeeList = field.data.ShowAttendeeList
                    docObj.SessionTypeDetails.ShowSpeakerList = field.data.ShowSpeakerList
                    docObj.SessionTypeDetails.AudiencePoll = field.data.AudiencePoll
                    docObj.SessionTypeDetails.EnableGroupChat = field.data.EnableGroupChat
                } else if (field.data.TypeID == 5) {
                    docObj.SessionTypeDetails.EnableGroupChat = field.data.EnableGroupChat
                    docObj.SessionTypeDetails.ShowAttendeeList = field.data.ShowAttendeeList
                    docObj.SessionTypeDetails.ShowSpeakerList = field.data.ShowSpeakerList
                    docObj.SessionTypeDetails.EnableRaiseHand = field.data.EnableRaiseHand
                    docObj.SessionTypeDetails.ShowAgenda = field.data.ShowAgenda
                    docObj.SessionTypeDetails.QnAModeration = field.data.QnAModeration
                    docObj.SessionTypeDetails.AllowPostingQuestionsAnonymously = field.data.AllowPostingQuestionsAnonymously
                    docObj.SessionTypeDetails.QnAAutoPublish = field.data.QnAAutoPublish
                    docObj.SessionTypeDetails.EnableLiveQnA = field.data.EnableLiveQnA
                    docObj.SessionTypeDetails.AudiencePoll = field.data.AudiencePoll
                } else if (field.data.TypeID == 6) {
                    docObj.SessionTypeDetails.EnableGroupChat = field.data.EnableGroupChat
                    docObj.SessionTypeDetails.QnAModeration = field.data.QnAModeration
                    docObj.SessionTypeDetails.AllowPostingQuestionsAnonymously = field.data.AllowPostingQuestionsAnonymously
                    docObj.SessionTypeDetails.QnAAutoPublish = field.data.QnAAutoPublish
                    docObj.SessionTypeDetails.EnableLiveQnA = field.data.EnableLiveQnA
                    docObj.SessionTypeDetails.AudiencePoll = field.data.AudiencePoll
                }

                let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                let headers = {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${accessToken}`
                }
                let requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                    },
                    "data": docObj
                };
                axios.put(AddSessionAPI, requestData, { headers: headers }).then(function (res) {
                    if (res.data.status == 0)
                        resolve({ status: 200, message: 'Data Updated.' })
                    else
                        resolve({ status: 500, message: 'Data not Updated.' })
                })
                /*sessionRef.doc(`${field.id}`).update(docObj).then(function () {
                    resolve({ status: 200, message: 'Data Updated.' })
                })*/
            })
        })
    },
    updateBottomBarActiveDisplay(context, field) {
        debugger;
        return new Promise((resolve, reject) => {
            if (field.data.TypeID == 1 || field.data.TypeID == 2) {
                sessionRef.doc(`${field.id}`).get().then(function (doc) {
                    if (doc.exists) {
                        let sessionTypeDetails = doc.data().SessionTypeDetails;
                        sessionTypeDetails.Active = field.data.Active;
                        if (sessionTypeDetails.TypeID == 1 || sessionTypeDetails.TypeID == 2) {
                            sessionRef.doc(`${field.id}`).update({
                                SessionTypeDetails: sessionTypeDetails
                            }).then(function () {
                                resolve({ status: 200, message: 'Data Updated.' })
                            })
                        }
                    }
                })
            }
        })
    },
    addSession(context, field) {
        return new Promise((resolve, reject) => {
            let track = {
                TrackID: '',
                TrackName: '',
                ColorCode: ''
            }
            if (field.data.Track) {
                track = field.data.Track;
            }
            sessionRef
                .where("Name", "==", field.data.Name.trim())
                .where("StartDate", "==", (field.data.StartDate ? field.data.StartDate : null))
                .get().then(function (snapShot) {
                    let doc = snapShot.docs[0];
                    if (snapShot.empty) {
                        //-----------------------------------------------------------------------------------------------------------
                        let docObj = {
                            SessionId: null,
                            //AutoID: AutoID,
                            Description: field.data.Description,
                            DescriptionShort: field.data.DescriptionShort,
                            //StartDate: new Date(field.data.StartDate),
                            //EndDate: new Date(field.data.EndDate),
                            StartDate: (field.data.StartDate ? field.data.StartDate : null),
                            EndDate: (field.data.EndDate ? field.data.EndDate : null),
                            Timezone: Session_Event_TZ,
                            DisplayBeforeSessionEndSecs: (field.data.DisplayBeforeSessionEndSecs ? field.data.DisplayBeforeSessionEndSecs : 60),
                            ShowSessionEndNotificationMessage: (field.data.ShowSessionEndNotificationMessage != undefined ? field.data.ShowSessionEndNotificationMessage : true),
                            NotificationMessage: (field.data.NotificationMessage ? field.data.NotificationMessage : null),
                            StartNotificationMessage: con.Environment == 'EDU' ? "Dear {{FirstName}} You have an upcoming class for {{EventName}} {{SessionName}} Date: {{StartDate}} - {{EndTime}}. Please login {{CountDownTime}} before your session." : "Dear {{FirstName}} this is a gentle reminder that {{SessionName}} of {{EventName}} will begin in {{CountDownTime}}. Date: {{StartDate}} to {{EndDate}}.",
                            Location: field.data.Location,
                            MappedSpeakers: field.data.MappedSpeakers,
                            MappedHosts: field.data.MappedHosts,
                            MappedCoHost: field.data.StreamingClient == 'Web' ? field.data.MappedCoHost : null,
                            Name: field.data.Name.trim(),
                            IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,
                            SessionSettings: field.data.SessionSettings,
                            SessionVisibleFor: field.data.SessionVisibleFor,
                            Resources: [],
                            StreamingClient: field.data.TypeID == 3 ? field.data.StreamingClient : "Web",
                            approval_type: field.data.approval_type != undefined ? field.data.approval_type : 0,
                            IsZoomRTMP: field.data.TypeID == 3 ? field.data.IsZoomRTMP : false,
                            IsRTMP: field.data.TypeID == 3 ? field.data.IsRTMP : false,
                            WebinarCapacity: field.data.TypeID == 3 ? field.data.WebinarCapacity : null,
                            SpeakersJoinZoomWebSDK: field.data.SpeakersJoinZoomWebSDK ? field.data.SpeakersJoinZoomWebSDK : false,
                            Track: track,
                            Batch: ['EDU', 'UAT'].includes(con.Environment) ? field.Batch : null,
                            //CreatedDate: new Date(),
                            //LastModifiedDate: new Date(),
                            SessionLogo: field.data.SessionLogo ? field.data.SessionLogo : ""
                        }

                        if (field.data.TypeID == 1) {
                            docObj.SessionTypeDetails = {
                                TypeID: 1,
                                TypeName: "On Demand",
                                PlayerControl: field.data.PlayerControl,
                                EnableGroupChat: field.data.EnableGroupChat,
                                ShowAttendeeList: field.data.ShowAttendeeList,
                                EnableBottomBar: field.data.EnableBottomBar,
                                PhotoWallAlbum: field.data.PhotoWallAlbum,
                                EmbedCode: field.data.EmbedCode,
                                Active: field.data.Active,
                                VideoURL: field.data.IsManualUrl ? field.data.ODVideoURL : null,
                                VideoLengthMinutes: field.data.ODVideoLengthMinutes
                            }

                        } else if (field.data.TypeID == 2) {
                            docObj.SessionTypeDetails = {
                                TypeID: 2,
                                TypeName: "Live Stream",
                                LiveStreamURL: field.data.IsManualUrl ? field.data.LSVideoURL : null,
                                RTMPURL: field.data.RTMPURL,
                                PlayerControl: field.data.PlayerControl,
                                EnableGroupChat: field.data.EnableGroupChat,
                                ShowAttendeeList: field.data.ShowAttendeeList,
                                EnableBottomBar: field.data.EnableBottomBar,
                                PhotoWallAlbum: field.data.PhotoWallAlbum,
                                EmbedCode: field.data.EmbedCode,
                                Active: field.data.Active,
                                StartDateTime: (field.data.LSDateTime ? field.data.LSDateTime : null),
                                StreamLengthMinutes: field.data.LSVideoLengthMinutes,
                                StreamKey: field.data.StreamKey
                            }
                        } else if (field.data.TypeID == 3) {
                            docObj.SessionTypeDetails = {
                                TypeID: 3,
                                TypeName: "Live Panel",
                                QnAModeration: field.data.QnAModeration,
                                AllowPostingQuestionsAnonymously: field.data.AllowPostingQuestionsAnonymously,
                                ConvertToOnDemandVideoOnSessionEnd: field.data.ConvertToOnDemandVideoOnSessionEnd,
                                QnAAutoPublish: field.data.QnAAutoPublish,
                                EnableHelpORSettings: field.data.EnableHelpORSettings,
                                EnableLiveQnA: field.data.EnableLiveQnA,
                                EnableRaiseHand: field.data.EnableRaiseHand,
                                EnableInviteSessionAttendee: field.data.EnableInviteSessionAttendee,
                                EnableSpotlight: field.data.EnableSpotlight,
                                ShowAgenda: field.data.ShowAgenda,
                                ShowAttendeeList: field.data.ShowAttendeeList,
                                ShowSpeakerList: field.data.ShowSpeakerList,
                                AudiencePoll: field.data.AudiencePoll,
                                EnableGroupChat: field.data.EnableGroupChat,
                                EnableBreakoutRoom: field.data.EnableBreakoutRoom ? field.data.EnableBreakoutRoom : false
                            }
                        } else if (field.data.TypeID == 4) {
                            docObj.SessionTypeDetails = {
                                TypeID: 4,
                                TypeName: "Round Table",
                                RoundTableTopic: field.data.RoundTables,
                                MapExistingRoundTableGroup: field.data.MapExistingRoundTableGroup != undefined ? field.data.MapExistingRoundTableGroup : true,
                                RTStreamingClient: field.data.RTStreamingClient ? field.data.RTStreamingClient : 'Web',
                                //Spectate: field.data.Spectate != undefined ? field.data.Spectate : true,
                                Spectate: false,
                                PreAssigned: (field.data.TableType == 'Pre_assigned' ? true : false),
                                RTHost: field.data.RTHost ? field.data.RTHost : null,
                                NumberOfSeatsPerTable: field.data.NumberOfSeatsPerTable ? field.data.NumberOfSeatsPerTable : 0,
                                NumberOfTables: field.data.NumberOfTables ? field.data.NumberOfTables : 0
                            },
                                docObj.EnableBreakoutRoom = field.data.EnableBreakoutRoom ? field.data.EnableBreakoutRoom : false;


                        } else if (field.data.TypeID == 5) {
                            docObj.SessionTypeDetails = {
                                TypeID: 5,
                                TypeName: "Custom Url",
                                InPersonIcon: null,
                                InPersonLabel: null,
                                InPersonURL: null,
                                AttendeeURL: null,
                                SpeakerURL: null,
                                HostURL: null,
                                HideTime: field.data.HideTime,
                                HideJoinButton: field.data.HideJoinButton,
                                HideTrack: field.data.HideTrack,
                                HideTitle: field.data.HideTitle,
                                HideShortDescription: field.data.HideShortDescription,
                                HideSpeakers: field.data.HideSpeakers,
                                ShowInSeparateRow: field.data.ShowInSeparateRow,
                                ShowBeforeConcurrentSessions: field.data.ShowBeforeConcurrentSessions,
                                ShowFeatureImage: field.data.ShowFeatureImage,
                                FeatureImage: field.data.FeatureImage
                            }
                        } else if (field.data.TypeID == 6) {
                            docObj.SessionTypeDetails = {
                                TypeID: 6,
                                TypeName: "In-person",
                                InPersonIcon: null,
                                InPersonLabel: null,
                            }
                        }

                        let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                        let headers = {
                            "Content-Type": "application/json",
                            'Authorization': `Bearer ${accessToken}`
                        }
                        let requestData = {
                            "key": {
                                "instanceId": "OA_UAT",
                                "clientId": Session_Client_Id,
                                "eventId": Session_Event_Id,
                            },
                            "data": docObj
                        };
                        axios.post(AddSessionAPI, requestData, { headers: headers }).then(function (res) {
                            console.log(res)
                            if (res.data.status == 0) {
                                let agendaAttendees = field.SelectedAttendees;
                                /*field.data.MappedSpeakers.filter(item=>{
                                    let found = field.SelectedAttendees.some(u=> item.AttendeeId == u.AttendeeId)
                                    if(!found)
                                        agendaAttendees.push(item)
                                })*/
                                let agendaMapObj = {
                                    sessions: [{
                                        SessionId: res.data.SessionId,
                                        StartDate: docObj.StartDate,
                                        EndDate: docObj.EndDate,
                                        Track: docObj.Track,
                                        Name: docObj.Name
                                    }],
                                    attendees: docObj.SessionVisibleFor.value == 3 ? agendaAttendees : [],
                                    unmap_attendees: [],
                                    mapgroups: docObj.SessionVisibleFor.value == 2 ? field.SelectedGroups : [],
                                    unmapgroups: []
                                }
                                if ([2, 3].includes(docObj.SessionVisibleFor.value)) {
                                    context.dispatch('agendaManagement/mapSessionAttendee', agendaMapObj, { root: true });
                                }
                                resolve({ status: 200, message: 'Data Added.', SessionId: res.data.SessionId })
                            }
                            else
                                resolve({ status: 500, message: res.data.Message })
                        }).catch(function (error) {
                            console.log(error)
                            reject(error)
                        })


                    } else {
                        resolve({ status: 500, message: 'Session already exists on the same date and time!' })
                    }
                }).catch(function (error) {
                    //console.log('Error getting attendee:', error)
                    reject(error)
                })



        })
    },
    fetchSessionBatches(context) {
        return new Promise((resolve, reject) => {
            let batches = [];
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }

            axios.get(`${GetSessionBatch}?iid=OA_UAT&cid=${Session_Client_Id}&eid=${Session_Event_Id}`, { headers: headers }).then(response => {
                let batches = response.data.result
                resolve(batches);
            });

        });
    },
    qnaPublishAll(context, field) {
        return new Promise((resolve, reject) => {
            let count = 0;
            qnaRef.doc(`${field.SessionId}`).collection('QnA').get().then(snapshot => {
                let totallength = snapshot.docs.length;
                if (totallength) {
                    snapshot.docs.forEach(docQnA => {
                        qnaRef.doc(`${field.SessionId}`).collection('QnA').doc(`${docQnA.id}`).get().then(function (doc) {
                            if (doc.data().Approved) {
                                qnaRef.doc(`${field.SessionId}`).collection('QnA').doc(`${docQnA.id}`).update({
                                    IsPublished: true,
                                    LastModifiedDate: new Date()
                                })
                            }
                            count = count + 1;
                            if (totallength == count)
                                resolve({ status: 200, message: 'QnA Status Changed of ' + count + ' Record' })
                        })
                    })
                } else {
                    resolve({ status: 200, message: 'No record to update.' })
                }
            }).catch(error => { console.log(error) })
        })
    },
    async getAutoId(context) {
        //let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function (doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function () {
                        con.instanceDB.doc("AutoID").get().then(function (doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        let AutoId = await promise;
        AutoId = AutoId * 1000;
        return await AutoId.toString();
    },
    getSettings(context) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('Sessions').doc('SessionsSettings').get().then(function (doc) {
                if (doc.exists) {
                    resolve(doc.data())
                } else {
                    resolve({ IsMyAgendaEnabled: false, VideoStreamProfile: { label: "High", value: "480p_1" } })
                }

            })
        })
        return promise;
    },
    saveSettings(context, field) {
        let promise = new Promise((resolve, reject) => {
            if (field.settingsData.SessionView != null) {
                let docObj = {
                    DefaultSessionPath: field.settingsData.SessionView == 'Calender' ? '/session_cal' : ''
                }
                con.eventDB.collection(cn).doc('EventInfo').update(docObj).then(function () {

                })
            }
            con.eventDB.collection(cn).doc("Settings").collection('Sessions').doc('SessionsSettings').get().then(function (doc) {
                if (field.IsDefaultSettings) {
                    field.settingsData.DefaultSettingsLoaded = true;
                    //context.dispatch('loadDefaultSettings');
                }
                if (doc.exists) {
                    let LiveStageBackgroundPotrait = doc.data().LiveStageBackgroundPotrait ? doc.data().LiveStageBackgroundPotrait : null
                    let LiveStageBackgroundLandscape = doc.data().LiveStageBackgroundLandscape ? doc.data().LiveStageBackgroundLandscape : null
                    let LiveStageLogo = doc.data().LiveStageLogo ? doc.data().LiveStageLogo : null
                    context.dispatch('uploadImage', { path: cn + '/Session/Settings/', file: field.LiveStageBackgroundPotraitFile }).then(LiveStageBackgroundPotraitURL => {
                        context.dispatch('uploadImage', { path: cn + '/Session/Settings/', file: field.LiveStageBackgroundLandscapeFile }).then(LiveStageBackgroundLandscapeURL => {
                            context.dispatch('uploadImage', { path: cn + '/Session/Settings/', file: field.LiveStageLogoFile }).then(LiveStageLogoURL => {
                                let docObj = field.settingsData;
                                docObj.LiveStageBackgroundPotrait = LiveStageBackgroundPotraitURL ? LiveStageBackgroundPotraitURL : LiveStageBackgroundPotrait;
                                docObj.LiveStageBackgroundLandscape = LiveStageBackgroundLandscapeURL ? LiveStageBackgroundLandscapeURL : LiveStageBackgroundLandscape;
                                docObj.LiveStageLogo = LiveStageLogoURL ? LiveStageLogoURL : LiveStageLogo
                                docObj.ActiveSpeakerFocus = false;
                                docObj.ActiveSpeakerMinVolume = 0;
                                docObj.ActiveSpeakerSorting = false;
                                docObj.DebugMode = false;
                                docObj.DefaultSessionPath = field.settingsData.SessionView == 'Calender' ? '/session_cal' : '';
                                con.eventDB.collection(cn).doc("Settings").collection('Sessions').doc('SessionsSettings').update(docObj).then(function () {
                                    resolve({ message: 'Data Updated.' });
                                });
                            })
                        })
                    })
                } else {
                    context.dispatch('uploadImage', { path: cn + '/Session/Settings/', file: field.LiveStageBackgroundPotraitFile }).then(LiveStageBackgroundPotraitURL => {
                        context.dispatch('uploadImage', { path: cn + '/Session/Settings/', file: field.LiveStageBackgroundLandscapeFile }).then(LiveStageBackgroundLandscapeURL => {
                            context.dispatch('uploadImage', { path: cn + '/Session/Settings/', file: field.LiveStageLogoFile }).then(LiveStageLogoURL => {
                                let docObj = field.settingsData;
                                docObj.LiveStageBackgroundPotrait = LiveStageBackgroundPotraitURL;
                                docObj.LiveStageBackgroundLandscape = LiveStageBackgroundLandscapeURL
                                docObj.LiveStageLogo = LiveStageLogoURL;
                                docObj.ActiveSpeakerFocus = false;
                                docObj.ActiveSpeakerMinVolume = 0;
                                docObj.ActiveSpeakerSorting = false;
                                docObj.DebugMode = false;
                                docObj.DefaultSessionPath = field.settingsData.SessionView == 'Calender' ? '/session_cal' : '';
                                con.eventDB.collection(cn).doc("Settings").collection('Sessions').doc('SessionsSettings').set(docObj).then(function () {
                                    resolve({ message: 'Data Saved.' });
                                });
                            })
                        })
                    })
                }
            })
        })
        return promise;
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
            let totallength = field.data.length;
            let count = 0;
            for (var i = 0; i < field.data.length; i++) {
                let data = field.data[i]
                sessionRef.doc(`${data.SessionId}`)
                    .update({ IsPublished: field.Status })
                    .then(function () {

                        count = count + 1;
                        if (totallength == count)
                            resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                    })
            }
        }) // end of promise
    },
    deleteResource(context, field) {
        return new Promise((resolve, reject) => {
            sessionRef.doc(`${field.id}`).update({
                Resources: firebase.firestore.FieldValue.arrayRemove(field.name)
            }).then(function (e) {
                resolve({ status: 200, message: 'resource deleted' })
            });
        })
    },
    updateSessionTypeDetail(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                LastModifiedDate: new Date()
            }


            sessionRef.doc(`${field.id}`).get().then(function (doc) {
                let SessionTypeDetails = doc.data().SessionTypeDetails
                if (field.TypeID == 1) {
                    docObj.SessionTypeDetails = {
                        TypeID: 1,
                        TypeName: "On Demand",
                        PlayerControl: SessionTypeDetails.PlayerControl ? SessionTypeDetails.PlayerControl : true,
                        VideoURL: SessionTypeDetails.VideoURL ? SessionTypeDetails.VideoURL : null,
                        VideoLengthMinutes: SessionTypeDetails.VideoLengthMinutes ? SessionTypeDetails.VideoLengthMinutes : null
                    }

                } else if (field.TypeID == 2) {
                    docObj.SessionTypeDetails = {
                        TypeID: 2,
                        TypeName: "Live Stream",
                        LiveStreamURL: SessionTypeDetails.LiveStreamURL ? SessionTypeDetails.LiveStreamURL : null,
                        RTMPURL: SessionTypeDetails.RTMPURL ? SessionTypeDetails.RTMPURL : null,
                        StartDateTime: (SessionTypeDetails.StartDateTime ? SessionTypeDetails.StartDateTime : null),
                        StreamLengthMinutes: SessionTypeDetails.StreamLengthMinutes ? SessionTypeDetails.StreamLengthMinutes : null,
                        StreamKey: SessionTypeDetails.StreamKey ? SessionTypeDetails.StreamKey : null
                    }
                }
                //console.log(SessionTypeDetails) 
                sessionRef.doc(`${field.id}`).update(docObj).then(function () {
                    resolve({ status: 200, message: 'Data Updated.' })
                }).catch(function (error) {
                    reject(error)
                })
            })
        })
    },
    uploadImage(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.path) {
                let path = field.path;
                let file = field.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(path + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve(null)
            }
        })
    },
    uploadVideo(context, field) {
        let url = "";
        let promise = new Promise((resolve, reject) => {
            const headers = {
                "Content-Type": "application/json"
            }

            var requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "sessionId": field.sessionId,
                "contentType": field.contentType,
                "fileName": field.filename,
                "file": field.file
            }

            var options = {
                headers: {
                    'Content-Type': field.file.type
                }
            };
            axios.post(S3GETVideoUploadURL, requestData, { headers: headers }).then((response) => {
                if (response.data.s3Url) {
                    var signedUrl = response.data.s3Url;
                    axios.put(signedUrl, field.file, options).then((res) => {
                        if (res.status == 200) {
                            axios.post(S3GETVideoDownloadURL, requestData, { headers: headers }).then((result) => {
                                console.log(result)
                                /*if(result.data.urls.length > 1)
                                    url = result.data.urls[result.data.urls.length - 1]
                                else if(result.data.urls.length)
                                    url = result.data.urls[0]
                                else
                                    url = ""*/
                                let date = moment.tz(moment(), Session_Event_TZ).format('MMMM DD, HH:mm A');
                                url = "Video Uploaded " + date + ". Trans-coding in progress...";
                                resolve({ status: 200, message: 'Video Uploaded.', url: url })
                            })
                        }
                    })

                }
            })

        }) // end of promise

        return promise;

    },
    uploadlsVideo(context, field) {
        let url = "";
        let promise = new Promise((resolve, reject) => {
            const headers = {
                "Content-Type": "application/json"
            }

            var requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "sessionId": field.sessionId,
                "contentType": field.contentType,
                "fileName": field.filename,
                "file": field.file
            }

            var options = {
                headers: {
                    'Content-Type': field.file.type
                }
            };
            axios.post(S3LSGETVideoUploadURL, requestData, { headers: headers }).then((response) => {
                console.log(response)
                if (response.data.s3Url) {
                    context.dispatch('setVideoScheduleTime', { sessionId: field.sessionId, scheduleInUTC: field.scheduleInUTC, Session_StartDate_UTC: field.Session_StartDate_UTC })
                    var signedUrl = response.data.s3Url;
                    axios.put(signedUrl, field.file, options).then((res) => {
                        console.log(res)
                        if (res.status == 200) {
                            let date = moment.tz(moment(), Session_Event_TZ).format('MMMM DD, HH:mm A');
                            url = "Video Uploaded " + date + ". Trans-coding in progress...";
                            context.dispatch('getLiveSessionInfo', { requestData: requestData }).then(function (res) {
                                resolve({ status: 200, message: 'Video Uploaded.', url: url })
                            })
                        }
                    })

                }
            })

        }) // end of promise

        return promise;

    },
    deleteAllNotificationScheduling(context, sessions) {
        return new Promise(async (resolve, reject) => {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            const headers = {
                "Content-Type": "application/json"
            }
            for (let i = 0; i < sessions.length; i++) {
                if (new Date(sessions[i].EndDate.seconds * 1000) < new Date()) {
                    const res = await context.dispatch("deleteNotificationSchedule", sessions[i]);
                }
            }
            resolve(true);
        })
    },
    async deleteNotificationSchedule(context, field) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            const headers = {
                "Content-Type": "application/json"
            }
            //let scheduledTaskId = `${Environment}_${Session_Event_Id}_S${field.SessionId}`
            let scheduledTaskId1 = field.StartNotificationScheduledTaskId ? field.StartNotificationScheduledTaskId : null
            let scheduledTaskId2 = field.StartNotificationScheduledTaskId_Secondary ? field.StartNotificationScheduledTaskId_Secondary : null
            let scheduledTaskId3 = field.StartNotificationScheduledTaskId_Third ? field.StartNotificationScheduledTaskId_Third : null

            /*axios.post(DeleteSchedulingAPI, { "scheduledTaskId": scheduledTaskId }, { headers: headers }).then((ress) => {
                if (ress.data.status == 0)
                    resolve(ress.data.scheduledTaskId)                
                else
                    resolve(null)
            }).catch(err=>{ reject(err) })*/
            axios.post(DeleteSchedulingAPI, { "scheduledTaskId": scheduledTaskId1 }, { headers: headers });
            axios.post(DeleteSchedulingAPI, { "scheduledTaskId": scheduledTaskId2 }, { headers: headers });
            axios.post(DeleteSchedulingAPI, { "scheduledTaskId": scheduledTaskId3 }, { headers: headers });
            resolve(true)
        })
    },
    async setNotificationSchedule(context, field) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            const headers = {
                "Content-Type": "application/json",
                //'Authorization': `Bearer ${accessToken}`,
            }

            let NotificationDateTime = new Date(field.StartDate);
            NotificationDateTime.setMinutes(NotificationDateTime.getMinutes() - Number(field.DisplayBeforeSessionStartMin));
            let scheduleInUTC = {
                year: NotificationDateTime.getUTCFullYear(),
                month: NotificationDateTime.getUTCMonth() + 1,
                day: NotificationDateTime.getUTCDate(),
                hour: NotificationDateTime.getUTCHours(),
                minute: NotificationDateTime.getUTCMinutes()
            };
            let NotificationDateTime2 = new Date(field.StartDate);
            NotificationDateTime2.setMinutes(NotificationDateTime2.getMinutes() - Number(field.DisplayBeforeSessionStartMin_Secondary));
            let scheduleInUTC_Secondary = {
                year: NotificationDateTime2.getUTCFullYear(),
                month: NotificationDateTime2.getUTCMonth() + 1,
                day: NotificationDateTime2.getUTCDate(),
                hour: NotificationDateTime2.getUTCHours(),
                minute: NotificationDateTime2.getUTCMinutes()
            };
            let NotificationDateTime3 = new Date(field.StartDate);
            NotificationDateTime3.setMinutes(NotificationDateTime3.getMinutes() - Number(field.DisplayBeforeSessionStart_Hour) * 60);
            let scheduleInUTC_third = {
                year: NotificationDateTime3.getUTCFullYear(),
                month: NotificationDateTime3.getUTCMonth() + 1,
                day: NotificationDateTime3.getUTCDate(),
                hour: NotificationDateTime3.getUTCHours(),
                minute: NotificationDateTime3.getUTCMinutes()
            };


            let NstartDateTime = moment.tz(new Date(field.StartDate), Session_Event_TZ).format("MMMM Do YYYY, hh:mm A");
            let NendDateTime = moment.tz(new Date(field.EndDate), Session_Event_TZ).format("MMMM Do YYYY, hh:mm A");
            let NendTime = moment.tz(new Date(field.EndDate), Session_Event_TZ).format("hh:mm A");

            let StartNotificationMessage = field.StartNotificationMessage.replace("{{CountDownTime}}", "5 mins").replace("{{SessionName}}", field.Name).replace("{{EventName}}", Session_Event_FullName).replace("{{StartDate}}", NstartDateTime).replace("{{EndDate}}", NendDateTime).replace("{{EndTime}}", NendTime);
            let StartNotificationMessage2 = field.StartNotificationMessage.replace("{{CountDownTime}}", "5 mins").replace("{{SessionName}}", field.Name).replace("{{EventName}}", Session_Event_FullName).replace("{{StartDate}}", NstartDateTime).replace("{{EndDate}}", NendDateTime).replace("{{EndTime}}", NendTime);
            let StartNotificationMessage3 = field.StartNotificationMessage.replace("{{CountDownTime}}", "5 mins").replace("{{SessionName}}", field.Name).replace("{{EventName}}", Session_Event_FullName).replace("{{StartDate}}", NstartDateTime).replace("{{EndDate}}", NendDateTime).replace("{{EndTime}}", NendTime);


            let SessionVisibleFor = "Everyone"
            if (field.SessionVisibleFor.value == 2)
                SessionVisibleFor = 'UserGroup'
            else if (field.SessionVisibleFor.value == 3)
                SessionVisibleFor = 'ListofAttendees'
            var request = {
                "url": StartNotificationSendAPI,
                "body": {
                    data: {
                        type: field.StartNotificationSendTo,
                        message: StartNotificationMessage,
                        Subject: field.NotificationSubject,
                        SessionVisibleFor: SessionVisibleFor,
                        ClientName: Session_ClientName,
                        EventName: Session_Event_FullName,
                        CountDownTime: `${field.DisplayBeforeSessionStartMin} mins`,
                        ClientDomain: Session_CustomDomain,
                        SessionName: field.Name
                    },
                    key: {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                        "sessionId": field.SessionId
                    }
                }
            }

            let scheduledTaskId = `${Environment}_${Session_Event_Id}_S${field.SessionId}`
            let scheduledTaskId2 = `${Environment}_${Session_Event_Id}_S${field.SessionId}_Secondary`
            let scheduledTaskId3 = `${Environment}_${Session_Event_Id}_S${field.SessionId}_third`

            axios.post(SchedulingAPI, { "scheduledTaskId": scheduledTaskId, "request": request, "scheduleInUTC": scheduleInUTC }, { headers: headers }).then((ress) => {
                if (ress.data.status == 0) {
                    request.body.data.CountDownTime = `${field.DisplayBeforeSessionStartMin_Secondary} mins`;
                    request.body.data.message = StartNotificationMessage2;
                    axios.post(SchedulingAPI, { "scheduledTaskId": scheduledTaskId2, "request": request, "scheduleInUTC": scheduleInUTC_Secondary }, { headers: headers }).then((res2) => {
                        if (res2.data.status == 0) {
                            request.body.data.CountDownTime = `${field.DisplayBeforeSessionStart_Hour} hrs`;
                            request.body.data.message = StartNotificationMessage3;
                            request.body.data.type = field.StartNotificationSendToThird == 'EmailOnly' ? 'Email' : 'EmailAndSMS';
                            axios.post(SchedulingAPI, { "scheduledTaskId": scheduledTaskId3, "request": request, "scheduleInUTC": scheduleInUTC_third }, { headers: headers }).then((res3) => {
                                if (res3.data.status == 0) {
                                    resolve({ scheduledTaskId: ress.data.scheduledTaskId, scheduledTaskId2: res2.data.scheduledTaskId, scheduledTaskId3: res3.data.scheduledTaskId, error: null })
                                }
                                else {
                                    resolve({ scheduledTaskId: ress.data.scheduledTaskId, scheduledTaskId2: res2.data.scheduledTaskId, scheduledTaskId3: null, error: res3.data.error, errorField: `Schedule ${field.DisplayBeforeSessionStart_Hour} Hour` })
                                }
                            })
                        }
                        else {
                            resolve({ scheduledTaskId: ress.data.scheduledTaskId, scheduledTaskId2: null, scheduledTaskId3: null, error: res2.data.error, errorField: `Schedule ${field.DisplayBeforeSessionStartMin_Secondary} Min` })
                        }
                    })
                }
                else {
                    resolve({ scheduledTaskId: null, scheduledTaskId2: null, scheduledTaskId3: null, error: ress.data.error, errorField: `Schedule ${field.DisplayBeforeSessionStartMin} Min` })
                }
            }).catch(err => { reject(err) })

        })
    },
    setVideoScheduleTime(context, field) {
        return new Promise((resolve, reject) => {
            const headers = {
                "Content-Type": "application/json"
            }
            var requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "sessionId": field.sessionId
            }

            //let Current_date_UTC = moment().tz(Session_Event_TZ).utc().format("'MM/DD/YYYY HH:mm'");
            //let minuteDiff = Current_date_UTC.diff(field.Session_StartDate_UTC, 'minutes')
            //console.log(Current_date_UTC)
            //console.log(field.Session_StartDate_UTC)
            //console.log("diff- "+minuteDiff)
            //if(minuteDiff < 15){
            axios.post(S3SETVideoScheduleTime, { "key": requestData, "scheduleInUTC": field.scheduleInUTC }, { headers: headers }).then((ress) => {
                console.log(ress)
                if (ress.data.scheduleCreateStatus == 0)
                    resolve({ status: 200, response: ress })
                else if (ress.data.scheduleCreateStatus < 0)
                    resolve({ status: 500, response: ress.data.error })
                else
                    resolve({ status: 200, response: ress })
            })
            /*}
            else
            {                
                resolve({status: 500, response: "The live-stream should start minimum 15 mins after the  selected session Date & time. Please adjust the time and try again."})
            }*/
        })
    },
    getLiveSessionInfo(context, field) {
        return new Promise((resolve, reject) => {
            const headers = {
                "Content-Type": "application/json"
            }
            axios.post(S3GETLiveSessionInfo, field.requestData, { headers: headers }).then((result) => {
                //console.log(result)                 
                resolve(result)
            })
        })
    },
    getSignedURL(context, field) {
        let getURL = null
        return new Promise((resolve, reject) => {
            const headers = {
                "Content-Type": "application/json"
            }
            var requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "sessionId": field.sessionId,
                "contentType": field.contentType,
                "fileName": field.filename,
                "file": field.file
            }
            if (field.TypeId == 1) {
                getURL = S3GETVideoUploadURL
            } else if (field.TypeId == 2) {
                getURL = S3LSGETVideoUploadURL
            }
            axios.post(getURL, requestData, { headers: headers }).then((result) => {
                //console.log(result)                 
                resolve(result)
            })
        })
    },
    removeMultiRecords(context, field) {
        return new Promise((resolve, reject) => {
            let totallength = field.data.length;
            let count = 0;
            for (var i = 0; i < field.data.length; i++) {
                let SessionId = field.data[i].SessionId

                context.dispatch('removeRecord', SessionId).then(value => {
                    count = count + 1;
                    if (totallength == count)
                        resolve({ status: 200, message: 'Total ' + count + ' Records Deleted' })
                })
            }
        })
    },
    removeRecord({ commit }, SessionId) {
        return new Promise((resolve, reject) => {
            sessionRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    if (doc.data().SessionId == SessionId) {
                        sessionRef.doc(doc.data().SessionId).delete().then(() => {
                            qnaRef.doc(doc.data().SessionId).delete().then(() => {
                                resolve({ status: 200, message: 'Record Deleted' })
                            }).catch(function (error) {
                                reject({ status: 0, message: 'Record Not Deleted' })
                            });
                        }).catch(function (error) {
                            reject({ status: 0, message: 'Record Not Deleted' })
                        });
                    }
                })

            })
                .catch(function (error) {
                    reject(error)
                });
        })
    },
    fetchZoomMeetingAnalytics(context, fieldObj) {
        return new Promise((resolve, reject) => {
            var requestData = {
                "meetingid": fieldObj
            };
            const headers = {
                "Content-Type": "application/json"
            }
            axios.post(ZoomMeetingAnalytics, requestData, { headers: headers }).then((response) => {
                console.log("response======", response);
                if (response.status == 200) {
                    resolve(response.data.participants)
                }
                else {
                    resolve(null)
                }
            }).catch(err => { console.error(err) })
        })
    },
    fetchZoomWebinarAnalytics(context, fieldObj) {
        return new Promise((resolve, reject) => {
            var requestData = {
                "webinarid": fieldObj
            };
            const headers = {
                "Content-Type": "application/json"
            }
            axios.post(ZoomWebinarAnalytics, requestData, { headers: headers }).then((response) => {
                console.log("response======", response);
                if (response.status == 200) {
                    resolve(response.data.participants)
                }
                else {
                    resolve(null)
                }
            }).catch(err => { console.error(err) })
        })
    },
    ZoomGetPlanUssage(context, fieldObj) {
        return new Promise((resolve, reject) => {
            const headers = {
                "Content-Type": "application/json"
            }
            axios.post(GetPlanUssage, { headers: headers }).then((response) => {
                if (response.status == 200) {
                    resolve(response.data)
                }
                else {
                    resolve(null)
                }
            }).catch(err => { console.error(err) })
        })
    },
    GetRecordedVideoUrls(context, fieldObj) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            const headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`,
                "x-api-key": DeleteAttendeeApiKey
            }
            var requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id.replace("E", "")
            }
            axios.post(RecordedVideoUrlsAPI, requestData, { headers: headers }).then((response) => {
                if (response.status == 200) {
                    resolve(response.data.result)
                }
                else {
                    resolve([])
                }
            }).catch(err => { console.error(err) })
        })
    },
    multipleSessionTypeConvert(context, sesionIds) {
        return new Promise((resolve, reject) => {
            let totallength = sesionIds.length;
            let count = 0;
            let doneCount = 0;
            let notdoneCount = 0;
            for (let i = 0; i < sesionIds.length; i++) {
                context.dispatch('livePanelToOnDemandVideo', sesionIds[i]).then(res => {
                    if (res.status == 200)
                        doneCount++;
                    else
                        notdoneCount++;
                    if ((doneCount + notdoneCount) == totallength) {
                        resolve({ status: 200, message: `Data updated ${doneCount} and not updated ${notdoneCount} of total ${totallength}` })
                    }
                })
            }
        })
    },
    livePanelToOnDemandVideo(context, sesionId) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken");
            let headers = {
                'Authorization': `Bearer ${accessToken}`,
                "content-type": 'application/json'
            }

            let eventIdWithoutE = Session_Event_Id.replace("E", "");
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id
                },
                "data": {
                    "recEventId": eventIdWithoutE,
                    "sessionId": sesionId,
                    "channelId": `OAUAT_${eventIdWithoutE}_${sesionId}`
                }
            }
            axios.post(LivePanelToOnDemandVideoAPI, requestData, { headers: headers }).then(response => {
                if (response.status == 200) {
                    resolve({ status: 200, message: response.data.result })
                }
                else {
                    resolve({ status: 500, message: "not done." })
                }
            }).catch(function (err) {
                resolve({ status: 500, message: "not done." })
                console.log(err);
            })
        })
    },
    enableZoomRTMPmeeting(context, fieldObj) {
        return new Promise((resolve, reject) => {
            let headers = {
                "content-type": "application/json"
            }
            let bodyData = {
                "meetingid": fieldObj.Zoom_Detail.id,
                "stream_url": fieldObj.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.url,
                "stream_key": fieldObj.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.streamKey,
                "page_url": fieldObj.ZoomRTMPMUX_detail.data.playbackUrl
            }
            axios.post(ZoomEnableRTMPmeeting, bodyData, { headers: headers }).then((response) => {
                sessionRef.doc(`${fieldObj.SessionId}`).update({
                    ZoomRTMPEnable_Status: response.data,
                    ZoomRTMPStarted: response.data.code == 1 ? true : false
                }).then(function () {
                    resolve(response.data)
                })
            })
        })
    },
    getMailTemplate(context) {
        var html = '';
        let subject = '';
        let sourcehtml = '';
        var count = 0;
        let promise = new Promise((resolve, reject) => {
            clientRef.get().then(function (clientDetail) {
                eventRef.get().then(function (eventDetail) {
                    //let StartDate = new Date(eventDetail.data().EventStartDate.seconds * 1000).toDateString() + " " + new Date(eventDetail.data().EventStartDate.seconds * 1000).toLocaleTimeString('en-US');
                    let EndDate = new Date(eventDetail.data().EventEndDate.seconds * 1000).toDateString() + " " + new Date(eventDetail.data().EventEndDate.seconds * 1000).toLocaleTimeString('en-US');

                    let StartDate = new Date(eventDetail.data().EventStartDate.seconds * 1000).toDateString()
                    let StartTime = new Date(eventDetail.data().EventEndDate.seconds * 1000).toLocaleTimeString('en-US')

                    let formatedText = {
                        CustomDomain: clientDetail.data().CustomDomain,
                        EventName: eventDetail.data().EventFullName,
                        //Email: "Email",
                        //Password: "Password",
                        //FirstName: "First Name",
                        //StartDate: StartDate,
                        //StartTime: StartTime,
                        //EndDate: EndDate,
                        //addtocalendarStartDate: addtocalendarStartDate,
                        //addtocalendarEndDate: addtocalendarEndDate,
                        EventBanner: eventDetail.data().EventBanner,
                        ClientName: clientDetail.data().ClientName,
                        //ClientAddress: "Client address if present"
                    };
                    let maitmplateRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection("mailtpl").doc("sessionReminder");
                    console.log(maitmplateRef)
                    maitmplateRef.get().then(function (mailtpl) {
                        if (mailtpl.exists) {
                            let sourcehtml = (mailtpl.data().html ? mailtpl.data().html : '')
                            let template = Handlebars.compile(sourcehtml);
                            let formatedhtml = template(formatedText);
                            html = (formatedhtml ? formatedhtml : 'Template not set!')
                            subject = (mailtpl.data().subject ? mailtpl.data().subject : null)
                            resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                        } else {
                            con.instanceDB.doc("mailtpl").collection("sessionReminder").doc('startNotification').get().then(function (mailtplinstnc) {
                                if (mailtplinstnc.exists) {
                                    maitmplateRef.set({ html: mailtplinstnc.data().html, subject: mailtplinstnc.data().subject }).then(function () {
                                        let sourcehtml = (mailtplinstnc.data().html ? mailtplinstnc.data().html : '')
                                        let template = Handlebars.compile(sourcehtml);
                                        let formatedhtml = template(formatedText);
                                        html = (formatedhtml ? formatedhtml : 'Template not set!')
                                        subject = (mailtplinstnc.data().subject ? mailtplinstnc.data().subject : null)
                                        resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                                    })
                                } else {
                                    html = 'Template not set!'
                                    subject = null
                                    sourcehtml = null
                                    resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                                }

                            }).catch(err => { console.log(err) })
                        }

                    }).catch(err => { console.log(err) })
                })
            })
        }) // end of promise

        return promise;
    },
    saveMail(context, field) {
        let sourcehtml = field.sourcehtml
        let subject = field.subject
        let maitmplateRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection("mailtpl").doc("sessionReminder");
        let promise = new Promise((resolve, reject) => {
            maitmplateRef.update({
                html: sourcehtml,
                subject: subject,
                UpdatedBy: Session_UserId,
                LastModifiedDate: new Date()
            }).then(function () {
                resolve({ message: "Mail Template Saved." })
            })
        })
        return promise;
    },
    getSessionUsersActivity(context, SessionId) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken");
            let headers = {
                "content-type": "application/json",
                'Authorization': `Bearer ${accessToken}`,
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id
                },
                "data": {
                    "sessionId": SessionId
                }
            }
            axios.post(rptsession, requestData, { headers: headers }).then((response) => {
                if (response.data.status == 0) {
                    let users = [];
                    for (let attendeeId in response.data.data) {
                        let obj = new Object;
                        obj = response.data.data[attendeeId].Attendee;
                        obj.AttendeeId = attendeeId;
                        obj.CHAT = response.data.data[attendeeId].CHAT;
                        obj.QNA = response.data.data[attendeeId].QNA;
                        obj.POLL = 0;
                        obj.JLTIME = response.data.data[attendeeId].JLTIME;
                        users.push(obj);
                    }
                    resolve(users);
                }
                else
                    resolve([]);
            }).catch(err => reject(err))
        })
    },
    generateQR(context, ids) {
        return new Promise((resolve, reject) => {
            let markers = [];
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },
                data: {
                    type: 'Session',
                    ids: ids,
                    fields: ['SessionId', 'Name', 'SessionLogo', 'StartDate', 'EndDate']
                }
            };
            axios.post(generateQR, requestData, { headers: headers }).then(function (res) {
                if (res.data.length) {
                    resolve({ status: 200, message: "QR generated Successfully.", data: res.data })
                } else {
                    resolve({ status: 500, message: "Unable to generate QR!" })
                }

            }).catch(function (error) {
                reject(error)
            })
        })
    },

}